// @ts-ignore
import { findIn, on, removeAttribute } from "@elements/dom-utils";
// @ts-ignore
import { getPrefixedDataSet } from "@elements/data-set-utils";
import { renderTemplate } from "./utils";
export function createUsercentricsOverlay(baseElement, options, selectors) {
    let data = getPrefixedDataSet(selectors.dataset, baseElement);
    consentQuery(baseElement, selectors, data, options);
    window.addEventListener('UC_UI_INITIALIZED', () => {
        consentQuery(baseElement, selectors, data, options);
    }, false);
}
function consentQuery(baseElement, selectors, data, options) {
    let button = findIn(selectors.button, baseElement);
    // @ts-ignore
    if (window.UC_UI && window.UC_UI.isInitialized()) {
        if (baseElement.hasAttribute('hidden')) {
            removeAttribute('hidden', baseElement);
        }
        checkConsentStatus(baseElement, selectors, data);
        window.addEventListener(options.revalidateEvent, (e) => {
            // @ts-ignore
            if (e.detail.action === 'onDenyAllServices') {
                // Reset user consent data
                location.reload();
            }
            // @ts-ignore
            checkConsentStatus(baseElement, selectors, data);
        }, false);
        if (button) {
            on('click', () => {
                // @ts-ignore
                window.UC_UI.acceptService(data.service).then(() => {
                    renderTemplate(baseElement, selectors);
                });
            }, button);
        }
    }
    ;
    // @ts-ignore
}
function checkConsentStatus(baseElement, selectors, data) {
    let serviceExplicitMapping = [];
    // @ts-ignore
    window.UC_UI.getServicesFullInfo().then((fullService) => {
        serviceExplicitMapping = fullService.map((obj) => {
            // @ts-ignore
            if (obj.id === data.service) {
                // @ts-ignore
                return obj.consent.status;
            }
        });
        serviceExplicitMapping.forEach((obj) => {
            if (obj === true) {
                renderTemplate(baseElement, selectors);
            }
            ;
        });
    }).catch((err) => { console.error(err); });
}
